module.exports = "/_next/static/images/statistics-3e6fe16cc71a5f821ddcd4f911350ed7.png";